import { gql } from '@apollo/client';

export const APPROVE_SALE = gql`
  mutation ApproveSale($saleId: ID!) {
    approveSale(sale_id: $saleId) {
      __typename
      sale_id
      status
      approved_by_user_id
      approved_at
      approved_document_count
    }
  }
`;
